<template>
    <v-row justify="center">
    <v-dialog
      v-model="dialog"
      persistent
      max-width="600px"
    >
      <v-card>
        <v-card-title>
          <span class="text-h5">Admin login</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-form ref="loginForm" >
                <v-row
                    cols="12"
                    sm="6"
                    md="4"
                >
                    <v-text-field
                    label="Username"
                    v-model="username"
                    :rules="[rules.required]"
                    ></v-text-field>
                </v-row>
                <v-row
                    cols="12"
                    sm="6"
                    md="4"
                >
                <v-text-field
                    label="password"
                    v-model="password"
                    :rules="[rules.required]"
                    type="password"
                ></v-text-field>
                </v-row>
            </v-form>
            <v-alert
                v-if="loginError"
                border="top"
                color="red lighten-2"
                dark
                transition="scale-transition"
                >Incorrect username or password
            </v-alert>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="blue darken-1"
            text
            @click="closeDialog(false)"
          >
            Cancel
          </v-btn>
          <v-btn
            color="blue darken-1"
            text
            @click="closeDialog(true)"
          >
            Login
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import axios from "axios";
export default {
    name: "Login",
    data() {
        return {
            dialog: false,
            username: '',
            password: '',
            rules: {
                required: value => !!value || 'Required.',
            },
            tokenApi: process.env.VUE_APP_ADMIN_AUTH,
            loginError: false
        };
    },
    props: {
        showDialog: {
            type: Boolean,
            default() {
                return false;
            },
        },
    },
    watch: {
        showDialog() {
            this.dialog = this.showDialog;
        },
    },
    methods: {
        closeDialog(login) {
            if(login && this.$refs.loginForm.validate()){
                axios.post(this.tokenApi, {
                    data: {
                        username: this.username,
                        password: this.password
                    }
                })
                .then(response => {
                    this.loginError = false
                    this.$store.commit("setToken", "Token " + response.data.token);
                    this.username = ''
                    this.password = ''
                    this.$emit("closeDialog")
                })
                .catch(error => {
                    console.log(error);
                    this.loginError = true
                });
            }
            if(!login){
                this.$emit("closeDialog")
                this.loginError = false
                this.dialog = false
                this.username = ''
                this.password = ''
            }
        }
    }
};
</script>

<style lang="scss" scoped>
</style>